import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import ArticleTable from "../../elements/Tables/ArticleTable/ArticleTable";
import ArticleCreationForm from "../../elements/Forms/ArticleCreationForm/ArticleCreationForm";

import { useFetch } from "../../../Utils/useFetch";

import {
  FETCH_ALL_ARTICLE_API,
  FETCH_ALL_FILTERED_ARTICLE_API,
  FETCH_ALL_CATEGORY_API,
  FETCH_ALL_BRAND_API,
  FETCH_ALL_SUBCATEGORY_API,
  FETCH_ALL_DIVISION_API,
  FETCH_ALL_TYPE_API,
  FETCH_ALL_PRINCIPLE_API
} from "../../../Constants/Apis";
import { Button, Flex, Input, message, Modal } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deleteArticle } from "../../../Services/ArticleService";

const { Search } = Input;

const ArticlePage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [articleId, setArticleId] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleDelete = async (id) => {
    setArticleId(id);
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await deleteArticle(articleId);
      message.success("Article deleted successfully");
      callReFetch();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete article."
      );
    }
    setIsModalOpen(false);
  };

  // Use filtered articles endpoint with counterCode so backend handles visibility
  const articleParams = {
    ...state,
    counterCode: userData?.counterCode,
  };

  const {
    fetchedData,
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_FILTERED_ARTICLE_API}`, articleParams);
  
  // Extract data and pagination safely
  const data = fetchedData?.data?.data || [];
  const responsePagination = fetchedData?.data?.pagination;

  // Backend now filters based on counterCode; ensure array shape
  const filteredData = Array.isArray(data) ? data : [];

  // Update pagination total when data changes
  React.useEffect(() => {
    if (
      responsePagination &&
      responsePagination.total !== state.pagination.total
    ) {
      dispatch({
        type: "pagination",
        payload: {
          ...state.pagination,
          total: responsePagination.total,
        },
      });
    }
  }, [responsePagination]);

  const {
    fetchedData: { data: categoryData },
    callReFetchCategory,
    loadingCategory,
  } = useFetch(`${FETCH_ALL_CATEGORY_API}`, state);

  const {
    fetchedData: { data: subCategoryData } = { data: [] }, // Ensure default empty array
    callReFetch: callReFetchSubCategory,
    loading: loadingSubCategory,
  } = useFetch(`${FETCH_ALL_SUBCATEGORY_API}/category/${selectedCategory}`);

  const {
    fetchedData: { data: divisionData },
    callReFetchDivision,
    loadingDivision,
  } = useFetch(`${FETCH_ALL_DIVISION_API}`, state);

  const {
    fetchedData: { data: brandData },
    callReFetchBrand,
    loadingBrand,
  } = useFetch(`${FETCH_ALL_BRAND_API}`, state);

  const {
    fetchedData: { data: typeData },
    callReFetchType,
    loadingType,
  } = useFetch(`${FETCH_ALL_TYPE_API}`, state);

    const {
      fetchedData: { data : principleData },
      callReFetchPrinciple,
      loadingPrinciple,
    } = useFetch(`${FETCH_ALL_PRINCIPLE_API}`, state);

  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    // Reset to first page when searching
    dispatch({
      type: "pagination",
      payload: {
        ...state.pagination,
        current: 1,
      },
    });
    callReFetch();
  };

  const handlePaginationChange = (pagination) => {
    dispatch({ type: "pagination", payload: pagination });
    callReFetch();
  };

  return (
    <div
      style={{
        width: "100vw",
        padding: "20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "70vw",
          maxWidth: "100vw",
        }}
      >
        <Button type="primary" onClick={handleOpenModal}>
          Create New Article
        </Button>
        <Search
          placeholder="Search..."
          allowClear
          onSearch={handleSearch}
          style={{ width: "300px" }}
        />
      </div>

      <ArticleTable
        history={history}
        loading={loading}
        data={filteredData}
        categoryData={categoryData}
        brandData={brandData}
        userData={userData}
        callReFetch={callReFetch}
        dispatch={dispatch}
        handleDelete={handleDelete}
        divisionData={divisionData}
        typeData={typeData}
        subCategoryData={subCategoryData}
        principleData={principleData}
        setSelectedCategory={setSelectedCategory}
        callReFetchSubCategory={callReFetchSubCategory}
        pagination={state.pagination}
        onPaginationChange={handlePaginationChange}
      />

      <Modal
        title="Create Article"
        open={isModalVisible}
        footer={null}
        onCancel={handleCloseModal}
      >
        <ArticleCreationForm
          history={history}
          userData={userData}
          categoryData={categoryData}
          brandData={brandData}
          callReFetch={callReFetch}
          onClose={handleCloseModal}
          callReFetchSubCategory={callReFetchSubCategory}
          subCategoryData={subCategoryData}
          principleData={principleData}
          loadingSubCategory={loadingSubCategory}
          setSelectedCategory={setSelectedCategory}
          callReFetchDivision={callReFetchDivision}
          callReFetchType={callReFetchType}
          divisionData={divisionData}
          typeData={typeData}
        />
      </Modal>

      <Modal
        title="Delete Article"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this article?</p>
      </Modal>
    </div>
  );
};

ArticlePage.propTypes = {};

export default ArticlePage;
